// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.new-customer-container{
    background-color: white;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
    position: absolute;
    top: 2vh;
    left: 20%;
    width: 60%;
    border-radius: 10px;
}
.new-customer-header{
    margin: 0px;
    padding: 15px 25px;
    width: 100%;
    border-radius: 10px 10px 0px 0px;
    background-color: rgba(155, 30, 30, 0.952);
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
}
.new-customer-header h3{
    margin: 0px;
    color: white;
    font-weight: lighter;
}
.new-customer-header p{
    margin: 0px;
    color: white;
    font-size: 20px;
    cursor: pointer;
}
.new-customer-body{
    padding-top: 20px;
}
.new-customer-property-component{
    margin: 20px;
    padding: 5px 10px;
    border-radius: 5px;
    background-color: lightgray;
}
.new-customer-property-component p{
    margin: 0px;
    font-size: 10px;
    color: gray;
}
.new-customer-property-component input{
    width: 100%;
    outline: none;
    border: none;
    background-color: transparent;
}
.new-customer-property-component select{
    margin: 0px;
    padding: 0px;
    background-color: transparent;
}
.new-customer-container-buttons{
    width: 100%;
    padding: 20px 50px;
    padding-right: 13px;
    text-align: right;
    box-sizing: border-box;
}
.new-customer-container-buttons button{
    padding: 10px 25px;
    margin: 0px 10px;
    border-radius: 5px;
    border: none;
    cursor: pointer;
    color: white;
    box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);
    background-color: rgba(155, 30, 30, 0.952);
    transition: opacity 0.2s ease;
}
.new-customer-container-buttons button:hover{
    opacity: 0.9;
}`, "",{"version":3,"sources":["webpack://./src/styles/workspace_styles/TenantAdministratorStyles/Customers/NewCustomer.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,sCAAsC;IACtC,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,UAAU;IACV,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,gCAAgC;IAChC,0CAA0C;IAC1C,sBAAsB;IACtB,aAAa;IACb,8BAA8B;AAClC;AACA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;AACxB;AACA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,eAAe;AACnB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,2BAA2B;AAC/B;AACA;IACI,WAAW;IACX,eAAe;IACf,WAAW;AACf;AACA;IACI,WAAW;IACX,aAAa;IACb,YAAY;IACZ,6BAA6B;AACjC;AACA;IACI,WAAW;IACX,YAAY;IACZ,6BAA6B;AACjC;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,sBAAsB;AAC1B;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,sCAAsC;IACtC,0CAA0C;IAC1C,6BAA6B;AACjC;AACA;IACI,YAAY;AAChB","sourcesContent":[".new-customer-container{\r\n    background-color: white;\r\n    box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);\r\n    position: absolute;\r\n    top: 2vh;\r\n    left: 20%;\r\n    width: 60%;\r\n    border-radius: 10px;\r\n}\r\n.new-customer-header{\r\n    margin: 0px;\r\n    padding: 15px 25px;\r\n    width: 100%;\r\n    border-radius: 10px 10px 0px 0px;\r\n    background-color: rgba(155, 30, 30, 0.952);\r\n    box-sizing: border-box;\r\n    display: flex;\r\n    justify-content: space-between;\r\n}\r\n.new-customer-header h3{\r\n    margin: 0px;\r\n    color: white;\r\n    font-weight: lighter;\r\n}\r\n.new-customer-header p{\r\n    margin: 0px;\r\n    color: white;\r\n    font-size: 20px;\r\n    cursor: pointer;\r\n}\r\n.new-customer-body{\r\n    padding-top: 20px;\r\n}\r\n.new-customer-property-component{\r\n    margin: 20px;\r\n    padding: 5px 10px;\r\n    border-radius: 5px;\r\n    background-color: lightgray;\r\n}\r\n.new-customer-property-component p{\r\n    margin: 0px;\r\n    font-size: 10px;\r\n    color: gray;\r\n}\r\n.new-customer-property-component input{\r\n    width: 100%;\r\n    outline: none;\r\n    border: none;\r\n    background-color: transparent;\r\n}\r\n.new-customer-property-component select{\r\n    margin: 0px;\r\n    padding: 0px;\r\n    background-color: transparent;\r\n}\r\n.new-customer-container-buttons{\r\n    width: 100%;\r\n    padding: 20px 50px;\r\n    padding-right: 13px;\r\n    text-align: right;\r\n    box-sizing: border-box;\r\n}\r\n.new-customer-container-buttons button{\r\n    padding: 10px 25px;\r\n    margin: 0px 10px;\r\n    border-radius: 5px;\r\n    border: none;\r\n    cursor: pointer;\r\n    color: white;\r\n    box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);\r\n    background-color: rgba(155, 30, 30, 0.952);\r\n    transition: opacity 0.2s ease;\r\n}\r\n.new-customer-container-buttons button:hover{\r\n    opacity: 0.9;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
